import React, { useEffect, useState } from "react";

import StyledPatientMaterials from "./StyledPatientMaterials";

import ViewCard from "../../common/ViewCard/ViewCard";
import axios from "axios";
import APIVariables from "../../../services/api-variables";
import LocalStorage from "../../../shared/localStorage";
import Footer from "../../common/Footer/Footer";
import {
  handleCatch,
  verifyUserType,
  verifyUserTypeConnectedRegistrar,
} from "../../../shared/helpers";
import { registrationCategory } from "../../../constants/register.constants";

const PatientMaterials = () => {
  const [patientsBrochures, setPatientsBrochures] = useState([]);

  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);
  const isPrescriber = verifyUserType(registrationCategory.PRESCRIBER);
  const isConnectedRegistrar = verifyUserTypeConnectedRegistrar(
    registrationCategory.CONNECTED_REGISTRAR
  );

  useEffect(() => {
    getBrochures();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getBrochures = async () => {
    const res = await axios
      .get(process.env.REACT_APP_BASE_URL + APIVariables.PATIENTS_BROCHURES, {
        headers: {
          Authorization: parseLocalStorage.token,
        },
      })
      .catch((error) => {
        handleCatch(error);
      });

    setPatientsBrochures(res.data);
  };

  const filterPharmacyBrochures = () => {
    return patientsBrochures.filter((elem) => elem.id >= 1 && elem.id <= 3);
  };

  return (
    <StyledPatientMaterials>
      <div className="wrapper">
        <div className="layout">
          <h1 className="h1">Healthcare Professional & Patient Materials</h1>
          <div className="cardsContainer">
            {(!isPrescriber && !isConnectedRegistrar
              ? filterPharmacyBrochures()
              : patientsBrochures || []
            ).map((item, index) => (
              <ViewCard brochure={item} index={index} key={index} isBase64 />
            ))}
          </div>
        </div>
        <Footer />
      </div>
    </StyledPatientMaterials>
  );
};
export default PatientMaterials;
